<template>
  <div class="analysis">
    <iframe :src="urlPath" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>

<script>
  export default {
    name: 'iframePage',
    data() {
      return {
        urlPath: 'zutai.html?'+Math.random()+'&type=1',
      };
    },
    props: {
      type: {
        type: Number,
        default: 1
      }
    },
    created() {
    //  console.log('000')
    //  console.log(this.$getCookie("projectId"))
    this.$store.commit("setProjectId", this.$getCookie("projectId"))
    // console.log(this.$store.state)
    this.urlPath = 'zutai.html?'+Math.random()+'&type=' + this.type + '&roomId=' + this.roomId + '&projectId=' + this.$getCookie("projectId");
    },
    computed: {
      isShowDet() {
        return this.$store.state.isShowDet;
      },
      roomId() {
        return this.$store.state.roomId;
      },
      projectId() {
        console.log(this.$store.state)
        return this.$getCookie("projectId");
      }
    },
    watch: {
      type(v) {
        this.urlPath = 'zutai.html?'+Math.random()+'&type=' + v + '&roomId=' + this.roomId + '&projectId=' + this.projectId;
          console.log(this.urlPath)
      },
      roomId(val) {
        this.urlPath = 'zutai.html?'+Math.random()+'&type=' + this.type + '&roomId=' + val + '&projectId=' + this.projectId;
      },
      projectId(val) {
        this.urlPath = 'zutai.html?'+Math.random()+'&type=' + this.type + '&roomId=' + this.roomId + '&projectId=' + val;
      }
    },
  };
</script>

<style lang="less" scoped>
  iframe {
    position: absolute;
    top: 120px;
    left: 34px;
    bottom: 0;
    width: calc( 100% - 68px);
    height: 780px;
    border: none;
  }
  .analysis {
    .change-box {
      background: #f8f8f9;
      padding: 20px;
      padding-bottom: 0;
      display: flex;
      margin-bottom: 20px;
      .item {
        font-size: 16px;
        padding-bottom: 15px;
        margin-right: 28px;
        cursor: pointer;
        &.active {
          font-weight: 600;
          border-bottom: 3px solid rgba(20, 96, 224, 1);
        }
      }
    }
  }
</style>